module.exports = __webpack_public_path__ + "static/media/logo.632cffcd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.svg
// module id = 587
// module chunks = 0